import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import useStoreAndLanguageParams from '../../../core/hooks/useStoreAndLanguageParams';
import Modal from '../../../core/components/Modal';
import CheckmarkIcon from '../../../core/components/icons/CheckmarkIcon';
import VerticalLayout from '../../../core/components/layout/VerticalLayout';
import Button from '../../../core/components/Button';
import styles from './AddToCartConfirmationModal.module.css';

export const AddToCartConfirmationModal = memo(
    ({
        setConfirmationModalOpen,
    }: {
        setConfirmationModalOpen: (isOpen: boolean) => void;
    }) => {
        const { storeRootPath } = useStoreAndLanguageParams();
        const targetPath = `${storeRootPath}/cart`;

        return (
            <Modal onClose={() => setConfirmationModalOpen(false)}>
                <div className={styles.confirmationModalContent}>
                    <CheckmarkIcon circular />
                    <div style={{ marginTop: 20, marginBottom: 66 }}>
                        <FormattedMessage id="the item has been successfully added to the shopping cart" />
                    </div>
                    <div className={styles.confirmationModalActions}>
                        <VerticalLayout gap="small" stretchChildren>
                            <Button
                                primary
                                fullWidth
                                linkTo={targetPath}
                                messageId="go to cart"
                            />
                            <Button
                                secondary
                                fullWidth
                                onPress={() => setConfirmationModalOpen(false)}
                                messageId="dismiss"
                            />
                        </VerticalLayout>
                    </div>
                </div>
            </Modal>
        );
    }
);
